/* EYESHELLS floating controls stability runtime v1458 */
(function (window, document) {
  'use strict';

  if (window.__esFloatingControlsCleanup) {
    try { window.__esFloatingControlsCleanup(); } catch (_cleanupError) {}
  }

  var root = document.documentElement;
  var body = document.body;
  var backToTop = document.getElementById('back-to-top');
  if (!root || !body || !backToTop) return;

  var CHAT_HOST_SELECTOR = [
    'inbox-online-store-chat',
    'shopify-chat',
    'shopify-inbox',
    'shopify-inbox-chat',
    '#shopify-chat',
    '#ShopifyChat',
    '#ShopifyInbox',
    '#ShopifyInboxLauncher',
    '#shopify-chat-dummy',
    '#dummy-chat-button-iframe',
    '.shopify-chat',
    '.shopify-inbox__launcher',
    '.ShopifyInbox__launcher',
    '.ShopifyInboxLauncher',
    '[data-shopify-chat]',
    '[data-shopify-inbox]',
    '[data-inbox-launcher]',
    '[id*="shopify-chat" i]',
    '[id*="shopify-inbox" i]',
    'iframe[src*="chat.shopify" i]',
    'iframe[src*="inbox" i]',
    'iframe[title*="chat" i]',
    'iframe[title*="inbox" i]'
  ].join(',');

  var CHAT_LAUNCHER_SELECTOR = [
    'button.chat-toggle',
    '.chat-toggle[role="button"]',
    'button[aria-label*="chat" i]',
    'button[aria-label*="message" i]',
    'button[title*="chat" i]',
    '[role="button"][aria-label*="chat" i]',
    '[role="button"][aria-label*="message" i]'
  ].join(',');

  var SUPPRESSION_CLASSES = [
    'es-qv-open',
    'es-lb-open',
    'es-tryon-clean-open',
    'es-size-guide-open',
    'es-size-guide-open-mobile',
    'es-mobile-filters-open',
    'es-mobile-sort-sheet-active',
    'es-search-modal-open',
    'es-search-open',
    'activemenu_mobile'
  ];

  var SHADOW_GLASS_CSS = [
    '[data-es-chat-glass="true"]{',
    'border:1px solid rgba(17,17,17,.13)!important;',
    'border-radius:16px!important;',
    'background:linear-gradient(145deg,rgba(255,255,255,.88),rgba(255,255,255,.68))!important;',
    'color:#111!important;',
    'overflow:hidden!important;',
    'background-clip:padding-box!important;',
    'box-shadow:0 9px 26px rgba(17,17,17,.16),inset 0 1px 0 rgba(255,255,255,.82)!important;',
    '-webkit-backdrop-filter:blur(14px) saturate(132%)!important;',
    'backdrop-filter:blur(14px) saturate(132%)!important;',
    'transition:background-color .18s ease,border-color .18s ease,box-shadow .18s ease,opacity .18s ease!important;',
    '}',
    '@media (hover:hover) and (pointer:fine){',
    '[data-es-chat-glass="true"]:hover{',
    'border-color:rgba(17,17,17,.18)!important;',
    'background:linear-gradient(145deg,rgba(255,255,255,.94),rgba(255,255,255,.76))!important;',
    'box-shadow:0 11px 30px rgba(17,17,17,.19),inset 0 1px 0 rgba(255,255,255,.9)!important;',
    '}',
    '}',
    '@supports not ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))){',
    '[data-es-chat-glass="true"]{background:rgba(255,255,255,.94)!important;}',
    '}',
    '@media (prefers-reduced-motion:reduce){',
    '[data-es-chat-glass="true"]{transition:none!important;}',
    '}'
  ].join('');

  var destroyed = false;
  var stateRaf = 0;
  var visibilityRaf = 0;
  var reducedMotion = false;

  var bodyObserver = null;
  var classObserver = null;

  var chatHosts = [];
  var chatRoots = [document];
  var hostObservers = [];
  var shadowObservers = [];
  var observedShadowRoots = [];
  var injectedShadowStyles = [];

  var visualSurface = null;
  var activeLauncher = null;
  var chatStructureDirty = true;

  function ensureBackToTopPortal() {
    if (backToTop.parentNode === body) return;
    try { body.appendChild(backToTop); } catch (_error) {}
  }

  function readReducedMotion() {
    try { reducedMotion = !!window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (_error) { reducedMotion = false; }
  }

  function getRect(element) {
    try { return element && element.getBoundingClientRect ? element.getBoundingClientRect() : null; }
    catch (_error) { return null; }
  }

  function getStyle(element) {
    try { return element ? window.getComputedStyle(element) : null; }
    catch (_error) { return null; }
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;
    var style = getStyle(element);
    if (!style || style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') <= 0) return false;
    var rect = getRect(element);
    return !!(rect && rect.width >= 2 && rect.height >= 2 && rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight);
  }

  function parentAcrossShadow(node) {
    if (!node) return null;
    if (node.parentElement) return node.parentElement;
    var treeRoot = null;
    try { treeRoot = node.getRootNode ? node.getRootNode() : null; } catch (_error) {}
    return treeRoot && treeRoot.host ? treeRoot.host : null;
  }

  function observeShadowRoot(shadowRoot) {
    if (!window.MutationObserver || !shadowRoot || observedShadowRoots.indexOf(shadowRoot) !== -1) return;
    observedShadowRoots.push(shadowRoot);
    var observer = new MutationObserver(function(mutations){
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].type === 'childList') chatStructureDirty = true;
      }
      scheduleStateSync();
    });
    try {
      observer.observe(shadowRoot, {
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:['class','hidden','aria-hidden','aria-expanded','is-open','open']
      });
      shadowObservers.push(observer);
    } catch (_error) {
      try { observer.disconnect(); } catch (_disconnectError) {}
    }
  }

  function collectOpenShadowRoots(host, roots, depth) {
    if (!host || depth > 1) return;
    var shadowRoot = null;
    try { shadowRoot = host.shadowRoot; } catch (_error) {}
    if (!shadowRoot || roots.indexOf(shadowRoot) !== -1) return;
    roots.push(shadowRoot);
    observeShadowRoot(shadowRoot);

    var nested = [];
    try { nested = shadowRoot.querySelectorAll('*'); } catch (_queryError) {}
    for (var i = 0; i < nested.length; i += 1) {
      if (nested[i].shadowRoot) collectOpenShadowRoots(nested[i], roots, depth + 1);
    }
  }

  function disconnectHostObservers() {
    for (var i = 0; i < hostObservers.length; i += 1) {
      try { hostObservers[i].disconnect(); } catch (_error) {}
    }
    hostObservers.length = 0;
  }

  function observeHosts() {
    disconnectHostObservers();
    if (!window.MutationObserver) return;
    for (var i = 0; i < chatHosts.length; i += 1) {
      var observer = new MutationObserver(scheduleStateSync);
      try {
        observer.observe(chatHosts[i], {
          attributes:true,
          attributeFilter:['class','style','hidden','aria-hidden','aria-expanded','is-open','open']
        });
        hostObservers.push(observer);
      } catch (_error) {
        try { observer.disconnect(); } catch (_disconnectError) {}
      }
    }
  }

  function sameElements(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i += 1) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  function refreshChatRoots() {
    if (!chatStructureDirty && chatHosts.length) {
      var allConnected = true;
      for (var connectedIndex = 0; connectedIndex < chatHosts.length; connectedIndex += 1) {
        if (!chatHosts[connectedIndex].isConnected) { allConnected = false; break; }
      }
      if (allConnected) return;
    }

    var hosts = [];
    try { hosts = Array.prototype.slice.call(document.querySelectorAll(CHAT_HOST_SELECTOR)); }
    catch (_error) { hosts = []; }

    if (!sameElements(hosts, chatHosts)) {
      for (var oldIndex = 0; oldIndex < chatHosts.length; oldIndex += 1) {
        try { chatHosts[oldIndex].removeAttribute('data-es-chat-root'); } catch (_removeError) {}
      }
      chatHosts = hosts;
      observeHosts();
    }

    var roots = [document];
    for (var i = 0; i < chatHosts.length; i += 1) {
      try { chatHosts[i].setAttribute('data-es-chat-root', 'true'); } catch (_markError) {}
      collectOpenShadowRoots(chatHosts[i], roots, 0);
    }
    chatRoots = roots;
    chatStructureDirty = false;
  }

  function launcherMetrics(element) {
    if (!isVisible(element)) return null;
    var rect = getRect(element);
    if (!rect || rect.width < 28 || rect.height < 28 || rect.width > 320 || rect.height > 190) return null;
    return {
      element:element,
      rect:rect,
      rightDistance:Math.max(0, window.innerWidth - rect.right),
      bottomDistance:Math.max(0, window.innerHeight - rect.bottom),
      area:rect.width * rect.height
    };
  }

  function findLauncher() {
    if (activeLauncher && launcherMetrics(activeLauncher)) return activeLauncher;

    var candidates = [];
    var seen = [];

    function addCandidate(element) {
      if (!element || seen.indexOf(element) !== -1) return;
      var metrics = launcherMetrics(element);
      if (!metrics) return;
      seen.push(element);
      candidates.push(metrics);
    }

    for (var r = 0; r < chatRoots.length; r += 1) {
      var controls = [];
      try { controls = chatRoots[r].querySelectorAll(CHAT_LAUNCHER_SELECTOR); } catch (_error) {}
      for (var c = 0; c < controls.length; c += 1) addCandidate(controls[c]);
    }

    if (!candidates.length) return null;

    candidates.sort(function (a, b) {
      var aEdge = a.rightDistance + a.bottomDistance;
      var bEdge = b.rightDistance + b.bottomDistance;
      if (aEdge !== bEdge) return aEdge - bEdge;
      return b.area - a.area;
    });

    var nearest = candidates[0];
    var group = candidates.filter(function (candidate) {
      return candidate.rightDistance <= nearest.rightDistance + 28
        && candidate.bottomDistance <= nearest.bottomDistance + 28;
    });

    group.sort(function (a, b) {
      if (a.area !== b.area) return b.area - a.area;
      return (a.rightDistance + a.bottomDistance) - (b.rightDistance + b.bottomDistance);
    });

    activeLauncher = group[0].element;
    return activeLauncher;
  }

  function injectGlassStyleFor(element) {
    if (!element || !element.getRootNode) return;
    var treeRoot = null;
    try { treeRoot = element.getRootNode(); } catch (_error) {}
    if (!treeRoot || treeRoot === document || treeRoot.nodeType !== 11) return;
    try {
      if (treeRoot.querySelector('style[data-es-chat-glass-style]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-es-chat-glass-style', 'true');
      style.textContent = SHADOW_GLASS_CSS;
      treeRoot.appendChild(style);
      injectedShadowStyles.push(style);
    } catch (_injectError) {}
  }

  function clearGlassSurface() {
    if (!visualSurface) return;
    try {
      visualSurface.removeAttribute('data-es-chat-glass');
      /* Remove the legacy dynamic radius left by older theme versions. */
      visualSurface.style.removeProperty('--es-chat-glass-radius');
    } catch (_error) {}
    visualSurface = null;
  }

  function applyGlassSurface(launcher) {
    if (!launcher || String(launcher.tagName || '').toLowerCase() === 'iframe') {
      clearGlassSurface();
      return;
    }

    /* The launcher button itself is the only glass target. Do not walk up and
       down Shopify's changing wrapper tree, and never derive radius from its
       transient dimensions. */
    if (launcher === visualSurface && launcher.isConnected) return;
    clearGlassSurface();
    visualSurface = launcher;

    try {
      visualSurface.style.removeProperty('--es-chat-glass-radius');
      visualSurface.setAttribute('data-es-chat-glass', 'true');
      injectGlassStyleFor(visualSurface);
    } catch (_error) {}
  }

  function hostLooksOpen(host) {
    if (!host || !host.isConnected) return false;
    try {
      if (host.hasAttribute('open')) return true;
      if (host.getAttribute('is-open') === 'true') return true;
      if (host.getAttribute('aria-expanded') === 'true') return true;
      if (host.getAttribute('aria-modal') === 'true') return true;
      if (/(?:^|\s)(?:open|active|expanded)(?:\s|$)/i.test(String(host.className || ''))) {
        var openRect = getRect(host);
        if (openRect && openRect.width >= 240 && openRect.height >= 200) return true;
      }
    } catch (_error) {}
    return false;
  }

  function chatPanelOpen() {
    for (var h = 0; h < chatHosts.length; h += 1) {
      if (hostLooksOpen(chatHosts[h])) return true;
      if (isVisible(chatHosts[h])) {
        var hostRect = getRect(chatHosts[h]);
        var hostTag = String(chatHosts[h].tagName || '').toLowerCase();
        if (hostTag === 'iframe' && hostRect && hostRect.width >= 260 && hostRect.height >= 220) return true;
      }
    }

    for (var r = 1; r < chatRoots.length; r += 1) {
      var dialogs = [];
      try { dialogs = chatRoots[r].querySelectorAll('[role="dialog"],[aria-modal="true"]'); } catch (_error) {}
      for (var d = 0; d < dialogs.length; d += 1) {
        if (!isVisible(dialogs[d])) continue;
        var rect = getRect(dialogs[d]);
        if (rect && rect.width >= 240 && rect.height >= 200) return true;
      }
    }
    return false;
  }

  function componentModalOpen() {
    for (var i = 0; i < SUPPRESSION_CLASSES.length; i += 1) {
      if (root.classList.contains(SUPPRESSION_CLASSES[i]) || body.classList.contains(SUPPRESSION_CLASSES[i])) return true;
    }
    return false;
  }

  function setSuppressionState(panelOpen, modalOpen) {
    root.setAttribute('data-es-chat-panel-open', panelOpen ? 'true' : 'false');
    root.setAttribute('data-es-modal-suppressed', modalOpen ? 'true' : 'false');
    root.setAttribute('data-es-floating-suppressed', panelOpen || modalOpen ? 'true' : 'false');
  }


  function isMobileCartPage() {
    return body.classList.contains('template-cart') && window.innerWidth <= 767.98;
  }

  /* Mobile cart visibility is CSS-owned via body.template-cart. The runtime only
     exposes the state attribute for back-to-top visibility; it never mutates
     Shopify Inbox inline styles. */

  function visibilityThreshold() {
    return Math.max(320, Math.min(560, Math.round(window.innerHeight * .55)));
  }

  function setBackToTopVisible(visible) {
    if (backToTop.classList.contains('show') === visible) return;
    backToTop.classList.toggle('show', visible);
    backToTop.setAttribute('aria-hidden', visible ? 'false' : 'true');
    backToTop.tabIndex = visible ? 0 : -1;
  }

  function updateVisibility() {
    var y = window.pageYOffset || root.scrollTop || body.scrollTop || 0;
    var suppressed = root.getAttribute('data-es-floating-suppressed') === 'true'
      || root.getAttribute('data-es-mobile-cart-floats-hidden') === 'true';
    setBackToTopVisible(y > visibilityThreshold() && !suppressed);
  }

  function syncState() {
    if (destroyed) return;
    ensureBackToTopPortal();
    refreshChatRoots();

    var launcher = findLauncher();
    var panelOpen = chatPanelOpen();
    var modalOpen = componentModalOpen();
    var mobileCartHidden = isMobileCartPage();

    if (mobileCartHidden) root.setAttribute('data-es-mobile-cart-floats-hidden', 'true');
    else root.removeAttribute('data-es-mobile-cart-floats-hidden');
    if (chatHosts.length) root.setAttribute('data-es-chat-present', 'true');
    else root.removeAttribute('data-es-chat-present');
    setSuppressionState(panelOpen, modalOpen);

    if (panelOpen || modalOpen || mobileCartHidden) clearGlassSurface();
    else applyGlassSurface(launcher);

    updateVisibility();
  }

  function scheduleStateSync() {
    if (destroyed || stateRaf) return;
    stateRaf = window.requestAnimationFrame(function () {
      stateRaf = 0;
      try { syncState(); }
      catch (error) {
        try { if (typeof window.ESDebug === 'function') window.ESDebug('floating-controls', error); }
        catch (_debugError) {}
      }
    });
  }

  function scheduleVisibility() {
    if (destroyed || visibilityRaf) return;
    visibilityRaf = window.requestAnimationFrame(function () {
      visibilityRaf = 0;
      updateVisibility();
    });
  }

  function focusTopTarget() {
    var target = document.querySelector('#MainContent,main,h1,#header');
    if (!target || !target.isConnected) return;
    var hadTabindex = target.hasAttribute('tabindex');
    var oldTabindex = target.getAttribute('tabindex');
    if (!hadTabindex) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll:true }); }
    catch (_error) { try { target.focus(); } catch (_focusError) {} }
    if (!hadTabindex) {
      target.addEventListener('blur', function cleanupTabindex() {
        target.removeEventListener('blur', cleanupTabindex);
        target.removeAttribute('tabindex');
      }, { once:true });
    } else if (oldTabindex !== null) {
      target.setAttribute('tabindex', oldTabindex);
    }
  }

  function onBackToTop(event) {
    event.preventDefault();
    readReducedMotion();
    try { window.scrollTo({ top:0, left:0, behavior:reducedMotion ? 'auto' : 'smooth' }); }
    catch (_error) { window.scrollTo(0, 0); }
    window.setTimeout(function () {
      updateVisibility();
      focusTopTarget();
    }, reducedMotion ? 0 : 420);
  }

  function onPageShow() {
    if (destroyed) return;
    scheduleStateSync();
  }

  function onPageHide(event) {
    if (event && event.persisted) return;
    cleanup();
  }

  function onVisibilityChange() {
    if (document.visibilityState !== 'hidden') scheduleStateSync();
  }

  function cleanup() {
    if (destroyed) return;
    destroyed = true;

    clearGlassSurface();
    disconnectHostObservers();

    if (stateRaf) window.cancelAnimationFrame(stateRaf);
    if (visibilityRaf) window.cancelAnimationFrame(visibilityRaf);
    if (bodyObserver) bodyObserver.disconnect();
    if (classObserver) classObserver.disconnect();

    for (var i = 0; i < shadowObservers.length; i += 1) {
      try { shadowObservers[i].disconnect(); } catch (_shadowError) {}
    }
    for (var j = 0; j < injectedShadowStyles.length; j += 1) {
      try { injectedShadowStyles[j].remove(); } catch (_styleError) {}
    }
    for (var h = 0; h < chatHosts.length; h += 1) {
      try {
        chatHosts[h].removeAttribute('data-es-chat-root');
      } catch (_hostError) {}
    }

    shadowObservers.length = 0;
    observedShadowRoots.length = 0;
    injectedShadowStyles.length = 0;
    chatHosts.length = 0;
    chatRoots = [document];
    activeLauncher = null;
    chatStructureDirty = true;

    window.removeEventListener('scroll', scheduleVisibility);
    window.removeEventListener('resize', scheduleStateSync);
    window.removeEventListener('orientationchange', scheduleStateSync);
    window.removeEventListener('pageshow', onPageShow);
    window.removeEventListener('pagehide', onPageHide);
    document.removeEventListener('visibilitychange', onVisibilityChange);
    document.removeEventListener('shopify:section:load', scheduleStateSync);
    backToTop.removeEventListener('click', onBackToTop);

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', scheduleStateSync);
    }

    root.removeAttribute('data-es-chat-present');
    root.removeAttribute('data-es-chat-panel-open');
    root.removeAttribute('data-es-modal-suppressed');
    root.removeAttribute('data-es-floating-suppressed');
    root.removeAttribute('data-es-mobile-cart-floats-hidden');
    backToTop.classList.remove('show');
    backToTop.setAttribute('aria-hidden', 'true');
    backToTop.tabIndex = -1;
  }

  readReducedMotion();
  ensureBackToTopPortal();
  backToTop.addEventListener('click', onBackToTop);
  window.addEventListener('scroll', scheduleVisibility, { passive:true });
  window.addEventListener('resize', scheduleStateSync, { passive:true });
  window.addEventListener('orientationchange', scheduleStateSync, { passive:true });
  window.addEventListener('pageshow', onPageShow, { passive:true });
  window.addEventListener('pagehide', onPageHide);
  document.addEventListener('visibilitychange', onVisibilityChange);
  document.addEventListener('shopify:section:load', scheduleStateSync);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleStateSync, { passive:true });
  }

  if (window.MutationObserver) {
    bodyObserver = new MutationObserver(function(mutations){
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes.length || mutations[i].removedNodes.length) {
          chatStructureDirty = true;
          scheduleStateSync();
          return;
        }
      }
    });
    /* Shopify app embeds are inserted as top-level body children. Avoid observing
       every product image, review widget and filter mutation across the page. */
    bodyObserver.observe(body, { childList:true });

    classObserver = new MutationObserver(scheduleStateSync);
    classObserver.observe(root, { attributes:true, attributeFilter:['class'] });
    classObserver.observe(body, { attributes:true, attributeFilter:['class'] });
  }

  window.__esFloatingControlsCleanup = cleanup;
  syncState();
})(window, document);
